import { render, staticRenderFns } from "./ModalModificarProfesional.vue?vue&type=template&id=bbd56f72&scoped=true&"
import script from "./ModalModificarProfesional.vue?vue&type=script&lang=js&"
export * from "./ModalModificarProfesional.vue?vue&type=script&lang=js&"
import style0 from "./ModalModificarProfesional.vue?vue&type=style&index=0&id=bbd56f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd56f72",
  null
  
)

export default component.exports